export default {
  methods: {
    offerHasPack (offer) {
      return offer.devices_packs !== undefined && offer.devices_packs.length > 0
    },

    showFullPrice (offer) {
      let fullPrice = this.firstOffer.mandatory_payment_frequency === 2
        ? offer.offer_price * 12 + ' € /an'
        : offer.offer_price + ' € /mois'

      if (offer.offer_price_mode === 'PER_DEVICE') {
        fullPrice += ' /appareil'
      }

      return fullPrice
    }
  }
}
